/**
 * Display name of an academic year.
 *
 * Establishments type the year either way — "2025/2026" or "2025-2026" — and
 * both end up stored as typed, so a tenant can finish with a mix of the two in
 * the same dropdown. Every screen displays them through here so the list reads
 * consistently, whatever was entered.
 */
export function formatAcademicYearName(name: string | null | undefined): string {
  if (!name) return '';
  return name.replace(/^(\d{4})\s*[-–—/]\s*(\d{4})$/, '$1/$2');
}
